import { c as _c } from "react/compiler-runtime";
import { addPrefixToDataParams } from '@/utils/string';
import { Field, Form } from 'react-final-form';
import { TextInput } from '@/components/inputs';
import { required, email, pipeValidators } from '@/utils/validators';
import { FIELD_BANK_CODE, FIELD_SECOND_PART, FIELD_THIRD_PART } from '@mallpay/orbis';
import dynamic from 'next/dynamic';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/buttons';
import useMediaQuery from '@/hooks/useMediaQuery';
import { getMediaQuery } from '@/styles/sizes';

// Dynamic import for BankAccountInput to avoid SSR issues
const BankAccountInput = dynamic(() => import('@mallpay/orbis').then(mod => ({
  default: mod.BankAccountInput
})), {
  ssr: false,
  loading: () => <div className="h-14 w-full rounded-2xl bg-gray-50 opacity-50" />
});
interface Props {
  handleSubmit: (values: {
    email: string;
    bankAccount: {
      [FIELD_BANK_CODE]: string;
      [FIELD_SECOND_PART]: string;
      [FIELD_THIRD_PART]?: string;
    };
  }) => Promise<void>;
  isLoggedIn: boolean;
  disabled: boolean;
}
export function RefundToAccountForm(props) {
  const $ = _c(19);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["overpayRefund", "core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getMediaQuery("lg");
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isDesktop = useMediaQuery(t1);
  let t2;
  if ($[2] !== t) {
    t2 = value => {
      if (!value) {
        return t("core:forms.error.required");
      }
      const values = Object.values(value);
      if (values.every(_temp)) {
        return t("core:forms.error.required");
      }
      if (!value[FIELD_BANK_CODE] || !value[FIELD_SECOND_PART]) {
        return t("fields.bankAccountRequired");
      }
    };
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const validateBankAccount = t2;
  let t3;
  if ($[4] !== props.isLoggedIn || $[5] !== t) {
    t3 = props.isLoggedIn && <p className="text-left text-lg">{t("refundToAccount.text")}</p>;
    $[4] = props.isLoggedIn;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isDesktop || $[8] !== props.disabled || $[9] !== props.isLoggedIn || $[10] !== t || $[11] !== validateBankAccount) {
    t4 = t5 => {
      const {
        handleSubmit,
        submitting
      } = t5;
      return <form encType="multipart/form-data" method="post" onSubmit={handleSubmit} {...addPrefixToDataParams({
        analyticsParam: "refund",
        testId: "refund",
        prefix: "form"
      })}><div className="flex flex-col justify-center gap-4">{!props.isLoggedIn ? <><div className="pt-0"><Field name="bankAccount" validate={validateBankAccount}>{fieldRenderProps => <BankAccountInput className="orbis-input-bank-account z-[9999]" {...fieldRenderProps} type="local" country="CZ" isMobile={!isDesktop} label={t("fields.bankAccount")} analyticsParam="refundToBankAccount" testId="refundToBankAccount" ariaLabels={{
                  [FIELD_BANK_CODE]: t("fields.bankCode"),
                  [FIELD_SECOND_PART]: t("fields.secondPart")
                }} />}</Field></div><Field name="email" type="email" validate={pipeValidators(required, email)}>{fieldRenderProps_0 => <TextInput {...fieldRenderProps_0} label={t("fields.email")} />}</Field></> : <div className="pt-6"><Field name="bankAccount" validate={validateBankAccount}>{fieldRenderProps_1 => <BankAccountInput className="orbis-input-bank-account z-[9999]" {...fieldRenderProps_1} type="local" country="CZ" label={t("fields.bankAccount")} analyticsParam="refundToBankAccount" testId="refundToBankAccount" ariaLabels={{
                [FIELD_BANK_CODE]: t("fields.bankCode"),
                [FIELD_SECOND_PART]: t("fields.secondPart")
              }} />}</Field></div>}<Button variant="primary" analyticsParam="refundToBankAccount" testId="refundToBankAccount" align="center" type="submit" disabled={props.disabled} busy={submitting}>{t("refundToAccount.button")}</Button></div></form>;
    };
    $[7] = isDesktop;
    $[8] = props.disabled;
    $[9] = props.isLoggedIn;
    $[10] = t;
    $[11] = validateBankAccount;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== props.handleSubmit || $[14] !== t4) {
    t5 = <Form onSubmit={props.handleSubmit} encType="multipart/form-data">{t4}</Form>;
    $[13] = props.handleSubmit;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t5) {
    t6 = <div className="flex flex-col gap-4">{t3}{t5}</div>;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}
function _temp(v) {
  return !v;
}